import { CONTACT_EMAIL, SOCIAL_URLS } from '@/lib/contact'
import { DEGREE, SCHOOL, SITE_NAME } from '@/lib/site'

/**
 * Canonical work history — the single source of truth for roles. The home page
 * (RESUME_DATA in src/app/page.tsx) and the MCP profile below both derive from
 * this, so a role's company/title/dates can't drift between the two. `end` is
 * 'Present' for the current role.
 */
export const workHistory = [
  {
    company: 'Benchmark Motion',
    title: 'Founding ML Engineer',
    start: '2025',
    end: 'Present',
  },
  {
    company: 'Lyra, now IRBC (YC X25)',
    title: 'Founding Engineer',
    start: '2025',
    end: '2025',
  },
  {
    company: 'iSharkz',
    title: 'Software Engineer',
    start: '2022',
    end: '2025',
  },
  {
    company: 'Rythm.fm',
    title: 'Contract Software Engineer',
    start: '2024',
    end: '2024',
  },
  { company: 'Leangap', title: 'Technical Mentor', start: '2021', end: '2024' },
] as const

// Display string for a role's span, e.g. '2022–2025' or '2024'.
const roleYears = (r: { start: string; end: string }) =>
  r.start === r.end ? r.start : `${r.start}–${r.end}`

export const profile = {
  name: SITE_NAME,
  headline: '0-to-1 product engineer shipping AI products end-to-end.',
  location: 'San Francisco, CA',
  currentRole: {
    company: workHistory[0].company,
    title: workHistory[0].title,
    start: workHistory[0].start,
  },
  priorRoles: workHistory.slice(1).map((r) => ({
    company: r.company,
    title: r.title,
    years: roleYears(r),
  })),
  education: {
    school: SCHOOL,
    degree: DEGREE,
    years: '2021–2024',
  },
  focusAreas: [
    'AI / ML product engineering',
    'Full-stack TypeScript / Next.js',
    'Real-time AI pipelines',
    '0-to-1 founding-engineer work',
  ],
  primaryStack: [
    'TypeScript',
    'Next.js',
    'React',
    'Expo / React Native',
    'Python',
    'PyTorch',
    'Postgres',
    'Supabase',
    'Drizzle ORM',
    'OpenAI / Anthropic / Gemini',
  ],
  socials: {
    email: CONTACT_EMAIL,
    twitter: SOCIAL_URLS.twitter,
    github: SOCIAL_URLS.github,
    linkedin: SOCIAL_URLS.linkedin,
    website: SOCIAL_URLS.website,
  },
  preferredContact: 'email',
  resumeUrl: 'https://arne.ai/resume',
  bookingUrls: {
    '15min': 'https://cal.com/arnenoori/15min',
    '30min': 'https://cal.com/arnenoori/30min',
  },
} as const
